export default { sha: '8420bb036c97dfb2e9bdf67ba561a899a8b78476', buildNumber: 'undefined' }
